import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { ErrorHandlerModule } from "./errors/error-handler.module";

@NgModule({
  imports: [
    HttpClientModule,
    //OAuthModule.forRoot(),
    ErrorHandlerModule.forRoot(),
  ],
  providers: [
    AuthService,

  ],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: []
    };
  }

  constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
